import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import styled, { css } from 'styled-components';
import { FormGroup, ControlGroup, InputGroup, TextArea } from '@blueprintjs/core';
import { Button, ButtonGroup, Dialog, Icon, FileInput, MenuItem } from '@blueprintjs/core';
import { HTMLSelect } from '@blueprintjs/core';
import { Popover2, Tooltip2 } from '@blueprintjs/popover2';
import { Select } from '@blueprintjs/select';
import { Alignment, Classes, IconSize, DrawerSize, Position, Colors, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Pannellum } from '$components/pannellum-react-local';
import { useAuth } from '$root/contexts/auth';


export const EditTagMode = {
    ADD: 0,
    EDIT: 1,
}


export default function AskAndEraseTagDialog(props)
{
    const { isOpen, projectId, documentId, tagId, onClose } = props
    const { getProtectedResource, deleteProtectedResource } = useAuth();

    const [ isWorking, setIsWorking ] = useState(false);
    const [ tagSettings, setTagSettings ] = useState({
        categories: [],
        disciplines: [],
        statuses: [],
    });
    const [ tagData, setTagData ] = useState({
        title:'',
        tagId:'',
        category:-1,
        discipline:-1,
        status:-1,
        comment:'',
        photo:null,
    });


    const onAddTag = useCallback(() => {

        setIsWorking(true);

        deleteProtectedResource(`/tag2.php?task=tag-delete&pid=${projectId}&did=${documentId}&tid=${tagId}`)
            .then((resp) => {
                console.log(resp)
                onClose(true);
            })
            .catch((err) => {
                console.error(err)
                onClose(false);
            })
        ;
    }, [tagData, setIsWorking]);


    useEffect(() => {
            Promise
                .all([
                    getProtectedResource(`/tag2.php?task=tag-settings&pid=${projectId}`),
                    getProtectedResource(`/tag2.php?task=tag-state&tid=${tagId}`)
                ])
                .then(([respSettings, respTag]) => {

                    const { categories, disciplines, statuses } = respSettings.data.settings;
                    const { tag } = respTag.data;

                    setTagSettings(old => ({
                        ...old,
                        categories:categories,
                        disciplines:disciplines,
                        statuses:statuses,
                    }));
                    setTagData(old => ({
                        ...old,
                        title:tag.title,
                        tag:tag.tag,
                        comment:tag.comment,
                        category:tag.category_id,
                        discipline:tag.discipline_id,
                        status:tag.status_id,
                    }));
                })
                .catch(() => {
                })
            ;
    }, []);


    const categoryOpts = (tagSettings.categories || []).map(category => (
        <option key={category.id} value={category.id}>{category.category}</option>
    ));

    const disciplineOpts = (tagSettings.disciplines || []).map(discipline => (
        <option key={discipline.id} value={discipline.id}>{discipline.discipline}</option>
    ));

    const statusOpts = (tagSettings.statuses || []).map(status => (
        <option key={status.id} value={status.id}>{status.status}</option>
    ));

    let caption = `Are you sure to delete tag: ${tagData.tag}?`;

    console.log(tagData)

    return (
        <Dialog
            title={caption}
            canEscapeKeyClose
            canOutsideClickClose
            isOpen={isOpen}
            onClose={onClose}
            style={{
                minWidth: '10rem',
                minHeight: '10rem',
                zIndex: 150
            }}
        >
            <div style={{width: '100%', height: '100%', padding:'1rem 1rem 0 1rem'}}>
                <FormGroup labelFor={'tag-title'} label={'Title'}>
                    <InputGroup
                        id={'tag-title'}
                        value={tagData.title}
                        disabled
                    />
                </FormGroup>
                <ControlGroup fill>
                    <FormGroup labelFor={'tag-category'} label={'Category'}>
                        <HTMLSelect
                            id={'tag-category'}
                            disabled
                            fill
                            value={tagData.category}
                        >
                            {categoryOpts}
                        </HTMLSelect>
                    </FormGroup>
                    <FormGroup labelFor={'tag-discipline'} label={'Discipline'}>
                        <HTMLSelect
                            id={'tag-discipline'}
                            disabled
                            fill
                            value={tagData.discipline}
                        >
                            {disciplineOpts}
                        </HTMLSelect>
                    </FormGroup>
                </ControlGroup>
                <ControlGroup fill>
                    <FormGroup labelFor={'tag-status'} label={'Status'}>
                        <HTMLSelect
                            id={'tag-status'}
                            disabled
                            fill
                            value={tagData.status}
                        >
                            {statusOpts}
                        </HTMLSelect>
                    </FormGroup>
                </ControlGroup>
                <FormGroup labelFor={'tag-desc'} label={'Comment'}>
                    <TextArea
                        id={'tag-desc'}
                        growVertically={false}
                        disabled
                        fill
                        value={tagData.comment}
                    />
                </FormGroup>

                <ControlGroup fill>
                    <div className={Classes.FILL} />
                    <Button text={'Delete'}
                            style={{minWidth:'6rem'}}
                            className={Classes.FIXED}
                            loading={isWorking}
                            onClick={onAddTag}
                            intent={Intent.DANGER}
                    />
                    <Button text={'Cancel'}
                            style={{minWidth:'6rem'}}
                            disabled={isWorking}
                            className={Classes.FIXED}
                            onClick={() => onClose(false)}
                    />
                </ControlGroup>
            </div>
        </Dialog>
    );
}